var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":"https://console.roanuz.com/","title":"Console","rel":"noopener"}},[_c('h1',[_vm._v("Hey "+_vm._s(_vm.bootData.user.name))])]),_c('p',[_vm._v(_vm._s(_vm.bootData))])])
}
var staticRenderFns = []

export { render, staticRenderFns }